import { createContext, useContext } from 'react';

export type EditContactView =
  | 'main'
  | 'tags'
  | 'searchLocation'
  | 'businessSelect'
  | 'businessMembers';

export type EditContactViewContextValue = {
  view: EditContactView;
  setView: (view: EditContactView) => void;
};

const noop: EditContactViewContextValue = { view: 'main', setView: () => {} };

const EditContactViewContext = createContext<EditContactViewContextValue | null>(null);

export const EditContactViewProvider = EditContactViewContext.Provider;

export const useEditContactView = () => {
  const ctx = useContext(EditContactViewContext);
  if (!ctx) {
    console.warn('[useEditContactView] using noop, context value is missing');
    return noop;
  }
  return ctx;
};
